import React from "react";
import { useNavigate } from "react-router-dom";

function Sidebar({ open, toggleSidebar }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div
      className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform ${
        open ? "translate-x-0" : "-translate-x-full"
      } transition-transform duration-300 ease-in-out`}
    >
      {/* Header with Welcome + Close Button */}
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-md font-semibold text-gray-700">
          Welcome, {user?.username || "User"}
        </h2>
        <button
          onClick={() => {
            toggleSidebar();
            navigate("/dashboard");
          }}
          className="text-gray-600 hover:text-red-600 text-xl font-bold"
        >
          ❌
        </button>
      </div>

      {/* Navigation Buttons */}
      {/* <nav className="flex flex-col p-4 space-y-3">
        <button
          className="text-left text-gray-700 hover:text-blue-600"
          onClick={() => {
            navigate("/dashboard");
            toggleSidebar();
          }}
        >
          Dashboard
        </button>
        <button
          className="text-left text-gray-700 hover:text-blue-600"
          onClick={() => {
            navigate("/submit-project");
            toggleSidebar();
          }}
        >
          Add Project
        </button>
      </nav> */}

      {/* Logout */}
      <div className="absolute bottom-0 w-full border-t p-4">
        <button
          onClick={logout}
          className="w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
